import React from "react";
import { PrimaryText, SecondaryText } from "../../styles/global";
import { ULContainer } from "./style";

const ExperienceList = [
  {
    company: "Empowered Futures",
    title: "Volunteer Software Developer ",
    date: "Nov 2023 - Present",
    status: "On-going",
    techStack: ["Next.js", "React", "TypeScript", "JavaScript", "SQL"],
    description: [
      "Assisted in remodelling the data structure of an existing SQL database, leading to a 40% improvement in data storage efficiency and a 70% reduction in retrieval times for appointment booking functionality.",
      "Developed an in-house onboarding system with a major focus on efficient data management and candidate analysis, saving the hiring team time by reducing the process from 7 days to 4 days per candidate.",
      "Enhanced development and deployment processes using Unix command line and bash scripting for automation.",
      "Supervised the adoption of agile methodologies within the organization, resulting in a 50% increase in software development efficiency and the earlier release of 2 major company projects' MVP versions.",
      "Implemented Progressive Web App (PWA) features with a mobile-first approach using Tailwind CSS.",
      "Reviewing and debugging pull requests (PRs) to resolve issues promptly and enhance code quality.",
    ],
  },
  {
    company: "RCIScience",
    title: "Data Analyst Intern",
    date: "April 2024- June 2024",
    techStack: ["Python", "Google Analytics", "Looker Studio", "Excel"],
    description: [
      "Collaborated with cross-functional teams to design and implement an ETL architecture for transitioning from Universal Analytics to Google Analytics 4, ensuring data tracking continuity.",
      "Analyzed massive datasets of website traffic data extracted from Google Analytics using Python and produced insights that led to forming strategies that increased marketing outcomes by 30%.",
      "Created dashboards in Looker Studio to analyze top social media platforms for customer acquisition, aiming to boost conversion rates by 50% in targeted marketing campaigns.",
      "Supported projects with comprehensive documentation of ETL processes, design decisions, and EDA insights, helping stakeholders understand and implement solutions effectively.",
    ],
  },
  {
    company: "IHUB DivyaSampark IIT Roorkee     ",
    title: "UG Fellowship ",
    date: "Feb 2023 -  June 2023",
    status: "completed",
    techStack: ["Machine Learning", "Python", "OpenCV", "React"],
    description: [
      "Awarded Chanakya UG Fellowship for research on 'Autonomous drone swarm for crime patrolling.'",
      "Created React-based desktop and mobile applications with APIs for data retrieval and analysis from the drone.",
      "Developed a computer vision ML-based solution using deep learning techniques that enhanced object recognition accuracy by 90% for autonomous drones.",
      "Collaborated with the research team to train and fine-tune ML models, resulting in a 25% improvement in detection range and reliability through drone lenses even at higher altitudes.",
      "Utilized OpenCV for duplicate image filtering which resulted in a 50% reduction in database storage space utilization.",
      "Designed and implemented Firebase as the backend database solution for efficient application data management.",
    ],
  },
  {
    company: "Vayana Network",
    title: "Junior Software Engineer Intern",
    date: "Jan 2023 - May 2023",
    status: "completed",
    techStack: [
      "TypeScript",
      "React",
      "Redux",
      "Next.js",
      "Jest",
      "AWS",
      "Python",
    ],
    description: [
      "Increased project development speed by 50% through contributions to an internal UI reusable components package.",
      "Designed and built a real-time data dashboard with React Chart.js 2 for insightful data visualizations.",
      "Defined multiple Jest unit testing cases with a focus on API response validation results to reduce post-release defects by approximately 25%.",
      "Contributed to the optimization of SQL queries, which resulted in an 80% reduction in query execution time and improved overall database performance.",
      "Integrated Redux Thunk middleware for state management and for enabling efficient handling of API requests.",
      "Utilized Next.js for efficient web app development, leveraging its features for enhanced performance.",
    ],
  },
  {
    company: "Vardaam Web solutions",
    title: "Front-End Developer Intern",
    date: "March 2022 - Aug 2022",
    status: "completed",
    techStack: [
      "React",
      "Redux",
      "JavaScript",
      "HTML",
      "CSS",
      "SCSS",
      "Bootstrap",
    ],
    description: [
      "Helped to develop and implement a feature-rich React web app for improving functionality and user experience.",
      "Collaborated closely with backend developers to seamlessly integrate REST APIs on the front end.",
      "Employed React lazy loading technique to optimize web application performance and reduce initial load times by 70%.",
      "Migrated the Laravel front-end to React.js, saving 5-8 hours monthly on maintenance, while boosting web app performance by 80%.",
    ],
  },
  {
    company: "E-Vidhya",
    title: "Front-End Developer Freelancer",
    date: "June 2021 - June 2022",
    status: "completed",
    techStack: ["React", "JavaScript", "Material UI", "CSS", "HTML"],
    description: [
      "Programmed end-to-end development of a web portal using React.js, from conceptualization to final product.",
      "Regularly updated the code based on requirements to enhance performance, resulting in a 40% improvement in speed.",
      "Utilized SCSS and Material UI frameworks to create visually appealing and responsive user interfaces.",
      "Revamped report generation facilities and dashboards, saving users 10-15 hours per week.",
    ],
  },
  {
    company: "Faith Foundation",
    title: "Social Intern",
    date: "Dec 2020 - Jan 2021",
    status: "completed",
    techStack: ["HTML", "CSS", "JavaScript"],
    description: [
      "Front-end developer, responsible for developing and enhancing web application UI.",
      "Integrated Google Translator tool for multi-language form, improving user accessibility and localization.",
      "Transformed form component into multi-step form, enhancing user flow and simplifying complex processes.",
      "Collaborated with backend developers to integrate front-end with backend systems.",
    ],
  },
];

const ExperienceContainer = () => {
  return (
    <div className="grid grid-cols-1  md:grid-cols-2  gap-8 items-start">
      {ExperienceList.map((experience, i) => {
        return (
          <div key={i} className="border card-shadow  rounded-lg p-6 h-full">
            <PrimaryText className="text-center font-bold">
              {experience.company}
            </PrimaryText>
            <div className="flex md:justify-between mt-4 md:items-center dur_pos_box">
              <div>
                <SecondaryText bg={"#ff5757"} className="font-bold ">
                  Duration:
                </SecondaryText>
                {experience.status === "On-going" ? (
                  <div
                    style={{
                      background:
                        "linear-gradient( 144deg,rgba(63, 94, 251, 1) 3%, rgba(252, 70, 107, 1) 100%)",
                    }}
                    className="py-1 px-2 inline-block rounded-md font-bold"
                  >
                    <SecondaryText className="">
                      {experience.date}
                    </SecondaryText>
                  </div>
                ) : (
                  <SecondaryText className="">{experience.date}</SecondaryText>
                )}
              </div>
              <div className="mt-4 md:mt-0">
                <SecondaryText
                  bg={"#ff5757"}
                  className="font-bold  text-gray-800 "
                >
                  Position:
                </SecondaryText>

                <SecondaryText className=" text-gray-800 ">
                  {experience.title}
                </SecondaryText>
              </div>
            </div>

            <div className="flex justify-between mt-4 items-center">
              <div>
                <SecondaryText bg={"#ff5757"} className="font-bold ">
                  Tech:
                </SecondaryText>

                <div className="flex">
                  {experience.techStack.map((tech, i) => {
                    return (
                      <div key={i} className="flex">
                        <SecondaryText key={i} className="mr-2">
                          {tech}{" "}
                          {i === experience.techStack.length - 1 ? "" : ","}
                        </SecondaryText>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div>
              <SecondaryText bg={"#ff5757"} className="font-bold mt-4">
                Description:
              </SecondaryText>
              <ULContainer>
                {experience.description.map((desc, i) => {
                  return (
                    <li key={i} className="text-sm p-[0.2rem] mt-1">
                      • {desc}
                    </li>
                  );
                })}
              </ULContainer>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ExperienceContainer;
